import React from "react";
import { useField } from "formik";
import ReactQuill from "react-quill";
import { Tag } from "lucide-react";
import "react-quill/dist/quill.snow.css";
import SectionCard from "../ui/SectionCard";
import Field from "../ui/Field";

const DescriptionField = ({ name, label, rtl }) => {
  const [field, meta, helpers] = useField(name);
  const invalid = meta.touched && !!meta.error;

  return (
    <Field label={label} required error={meta.touched ? meta.error : null}>
      <div
        className={`pf-editor-host ${rtl ? "pf-editor-host--rtl" : ""} ${
          invalid ? "is-invalid" : ""
        }`}
      >
        <ReactQuill
          theme="snow"
          value={field.value || ""}
          onChange={(value) => helpers.setValue(value)}
          onBlur={() => helpers.setTouched(true)}
        />
      </div>
    </Field>
  );
};

const BasicsSection = () => {
  const [nameField, nameMeta] = useField("name");
  const [arNameField, arNameMeta] = useField("ar_name");

  return (
    <SectionCard
      icon={<Tag size={16} />}
      title="Basics"
      subtitle="Product identity as shown to customers. Keep English and Arabic in sync."
      id="basics"
    >
      <div className="pf-grid pf-grid--2">
        <Field
          label="Name"
          required
          htmlFor="name"
          error={nameMeta.touched ? nameMeta.error : null}
        >
          <input
            id="name"
            {...nameField}
            className="pf-input"
            placeholder="Enter product name"
            aria-invalid={nameMeta.touched && !!nameMeta.error}
          />
        </Field>

        <Field
          label="Arabic Name"
          required
          htmlFor="ar_name"
          error={arNameMeta.touched ? arNameMeta.error : null}
        >
          <input
            id="ar_name"
            {...arNameField}
            className="pf-input pf-input--rtl"
            placeholder="أدخل اسم المنتج"
            aria-invalid={arNameMeta.touched && !!arNameMeta.error}
          />
        </Field>

        <DescriptionField name="description" label="Description" />
        <DescriptionField
          name="ar_description"
          label="Arabic Description"
          rtl
        />
      </div>
    </SectionCard>
  );
};

export default React.memo(BasicsSection);
